import { render, staticRenderFns } from "./EventSuperAdminTemplate.vue?vue&type=template&id=58b5c168&"
import script from "./EventSuperAdminTemplate.vue?vue&type=script&lang=ts&"
export * from "./EventSuperAdminTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports